import script from "./DampGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./DampGroup.vue?vue&type=script&setup=true&lang=js"

import "./DampGroup.vue?vue&type=style&index=0&id=87c7f1c6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87c7f1c6"]])

export default __exports__